import { safelyParseDate } from '@/utils/date';
import { FormHelperText, FormLabel, Grid } from '@mui/material';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { isAfter, isValid, roundToNearestMinutes } from 'date-fns';
import { useFormikContext } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';

const minDate = new Date();

const DateFields = ({ disabled }) => {
	const formik = useFormikContext();
	const { values, setFieldValue, touched, errors } = formik;

	const userPrefs = useSelector((state) => state.userPrefs);
	const timezone = userPrefs?.timezone;

	const setStartTime = (value) => {
		if (!value) return;
		const dueDate = safelyParseDate(values.dueDate) || new Date();
		const newStartTime = new Date(dueDate);
		newStartTime.setHours(value.getHours(), value.getMinutes(), 0, 0);
		const roundedStartTime = roundToNearestMinutes(newStartTime, {
			nearestTo: 15,
			roundingMethod: 'ceil',
		});
		setFieldValue('startTime', roundedStartTime);
		const endTime = new Date(roundedStartTime);
		endTime.setHours(roundedStartTime.getHours() + 1, 0, 0, 0);
		setFieldValue('endTime', endTime);
	};

	return (
		<>
			<Grid size={6}>
				<FormLabel required>{'Date'}</FormLabel>
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<DatePicker
						name='dueDate'
						disablePast={true}
						disabled={disabled}
						format='dd/MM/yyyy'
						value={values.dueDate}
						sx={{ width: '100%' }}
						onChange={(value) => {
							const newDate =
								!isValid(value) || isAfter(minDate, value) ? minDate : value;
							setFieldValue('dueDate', newDate);
							const currentStart = values.startTime;
							const newStart = new Date(newDate);
							newStart.setHours(
								currentStart.getHours(),
								currentStart.getMinutes(),
								0,
								0,
							);
							setFieldValue('startTime', newStart);
							const currentEnd = values.endTime;
							const newEnd = new Date(newDate);
							newEnd.setHours(currentEnd.getHours(), currentEnd.getMinutes(), 0, 0);
							setFieldValue('endTime', newEnd);
						}}
					/>
				</LocalizationProvider>
			</Grid>
			<Grid size={3}>
				<FormLabel required>{'Start Time'}</FormLabel>
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<TimePicker
						value={values.startTime}
						disabled={disabled}
						onChange={(value) => {
							if (value) {
								setStartTime(value);
							}
						}}
					/>
				</LocalizationProvider>
				{touched.startTime && errors.startTime && (
					<FormHelperText error>{errors.startTime}</FormHelperText>
				)}
			</Grid>
			<Grid size={3}>
				<FormLabel required>{'End Time'}</FormLabel>
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<TimePicker
						value={values.endTime}
						minTime={values.startTime}
						disabled={disabled}
						onChange={(value) => {
							const dueDate = new Date(values.dueDate);
							const newEndTime = new Date(dueDate);
							newEndTime.setHours(
								value.getHours(),
								value.getMinutes(),
								value.getSeconds(),
								value.getMilliseconds(),
							);
							setFieldValue('endTime', newEndTime);
						}}
					/>
				</LocalizationProvider>
				{touched.endTime && errors.endTime && (
					<FormHelperText error>{errors.endTime}</FormHelperText>
				)}
			</Grid>
		</>
	);
};

export default DateFields;
